module.exports = __webpack_public_path__ + "main/assets/public/on-air-banner/wave.796c859c60a5f6b1.svg";